import { useEffect, useState } from 'preact/hooks'

// Generic debounced value hook. Returns a debounced version of the provided value
// after the specified delay. Updates only after the user stops changing the value
// for the delay interval, reducing unnecessary filtering / network requests.
export function useDebouncedValue<T>(value: T, delay = 250): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(id)
  }, [value, delay])
  return debounced
}
